import { VoiceStyleOptionsType } from '@/pages/Onboarding/options/VoiceStyle/types.ts';

export const VOICE_STYLE_OPTIONS: VoiceStyleOptionsType = [
  {
    id: 'deep_hypnotic',
    title: 'Deep and hypnotic',
  },
  {
    id: 'cold_articulate',
    title: 'Cold and articulate',
  },
  {
    id: 'soft_dominant',
    title: 'Soft but dominant',
  },
  {
    id: 'whispering_threats',
    title: 'Whispering threats',
  },
];
